/**
 * Auto-detect visitor's country and set appropriate currency
 * Uses GeoIP data to intelligently set store currency
 */

(function() {
  'use strict';

  const CurrencyDetector = {
    // Currency codes by country
    countryToCurrency: {
      'US': 'USD',
      'CA': 'CAD',
      'GB': 'GBP',
      'AU': 'AUD',
      'NZ': 'NZD',
      'JP': 'JPY',
      'CN': 'CNY',
      'IN': 'INR',
      'DE': 'EUR',
      'FR': 'EUR',
      'IT': 'EUR',
      'ES': 'EUR',
      'NL': 'EUR',
      'BE': 'EUR',
      'AT': 'EUR',
      'CH': 'CHF',
      'SE': 'SEK',
      'NO': 'NOK',
      'DK': 'DKK',
      'BR': 'BRL',
      'MX': 'MXN',
      'SG': 'SGD',
      'HK': 'HKD',
      'KR': 'KRW',
      'IE': 'EUR',
      'NZL': 'NZD',
      'ZA': 'ZAR',
      'AE': 'AED',
      'SA': 'SAR',
      'TH': 'THB',
      'MY': 'MYR',
      'PH': 'PHP',
      'ID': 'IDR',
      'VN': 'VND',
      'PK': 'PKR',
      'UA': 'UAH',
      'RU': 'RUB',
      'TR': 'TRY',
      'IL': 'ILS',
      'EG': 'EGP',
      'NG': 'NGN',
      'PL': 'PLN',
      'CZ': 'CZK',
      'HU': 'HUF',
      'GR': 'EUR',
      'PT': 'EUR',
      'CL': 'CLP',
      'CO': 'COP',
      'PE': 'PEN',
      'AR': 'ARS'
    },

    // Get stored preference
    getStoredCurrency: function() {
      try {
        return localStorage.getItem('selected_currency');
      } catch (e) {
        return null;
      }
    },

    // Set currency preference
    setCurrency: function(currencyCode) {
      try {
        localStorage.setItem('selected_currency', currencyCode);
        // Trigger Shopify's currency change
        if (window.Currency && typeof window.Currency.convertAll === 'function') {
          window.Currency.currentCurrency = currencyCode;
          window.Currency.convertAll(window.shop.currency, currencyCode);
        }
      } catch (e) {
        console.warn('Currency detection: Could not set currency', e);
      }
    },

    // Fetch visitor's country from GeoIP API
    fetchCountry: async function() {
      try {
        // Use multiple GeoIP providers for reliability
        const response = await fetch('https://ipapi.co/json/');
        if (response.ok) {
          const data = await response.json();
          return data.country_code;
        }
      } catch (e) {
        console.warn('Currency detection: Could not fetch GeoIP data');
      }
      return null;
    },

    // Get currency for country
    getCurrencyForCountry: function(countryCode) {
      return this.countryToCurrency[countryCode] || null;
    },

    // Initialize
    init: async function() {
      // Skip if user already has a preference
      const storedCurrency = this.getStoredCurrency();
      if (storedCurrency) {
        this.setCurrency(storedCurrency);
        return;
      }

      // Detect country and set currency
      const countryCode = await this.fetchCountry();
      if (countryCode) {
        const currency = this.getCurrencyForCountry(countryCode);
        if (currency && currency !== window.shop.currency) {
          this.setCurrency(currency);
          console.log(`Currency auto-detected: ${countryCode} → ${currency}`);
        }
      }
    }
  };

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      CurrencyDetector.init();
    });
  } else {
    CurrencyDetector.init();
  }

  // Expose to window for manual control
  window.CurrencyDetector = CurrencyDetector;
})();
